// extracted by mini-css-extract-plugin
var _1 = "Notifications_author__VHRZB";
var _2 = "Notifications_board__BN-gr";
var _3 = "Notifications_date__Gj0K5";
var _4 = "Notifications_empty__u1FR9";
var _5 = "Notifications_firstItemButton__u7H1l";
var _6 = "Notifications_item__lejGq";
var _7 = "Notifications_itemButton__Zc1FT";
var _8 = "Notifications_itemContent__glztO";
var _9 = "Notifications_itemFullScreen__jQz0T";
var _a = "Notifications_itemHeader__TmgY-";
var _b = "Notifications_itemRead__RDKEA";
var _c = "Notifications_project__Sf4NC";
var _d = "Notifications_user__hj4uB";
export { _1 as "author", _2 as "board", _3 as "date", _4 as "empty", _5 as "firstItemButton", _6 as "item", _7 as "itemButton", _8 as "itemContent", _9 as "itemFullScreen", _a as "itemHeader", _b as "itemRead", _c as "project", _d as "user" }
